/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  StorageControllerUploadTemporaryFiles201,
  StorageControllerUploadTemporaryFilesBody,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * @summary 임시 파일 업로드 (견적 ID 불필요, 24시간 자동 삭제, 최대 10개 20MB)
 */
export const storageControllerUploadTemporaryFiles = (
  storageControllerUploadTemporaryFilesBody: BodyType<StorageControllerUploadTemporaryFilesBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  storageControllerUploadTemporaryFilesBody.files.forEach((value) =>
    formData.append(`files`, value),
  );

  return api<StorageControllerUploadTemporaryFiles201>({
    url: `/storage/upload-temporary`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getStorageControllerUploadTemporaryFilesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof storageControllerUploadTemporaryFiles>>,
    TError,
    { data: BodyType<StorageControllerUploadTemporaryFilesBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof storageControllerUploadTemporaryFiles>>,
  TError,
  { data: BodyType<StorageControllerUploadTemporaryFilesBody> },
  TContext
> => {
  const mutationKey = ["storageControllerUploadTemporaryFiles"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof storageControllerUploadTemporaryFiles>>,
    { data: BodyType<StorageControllerUploadTemporaryFilesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return storageControllerUploadTemporaryFiles(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type StorageControllerUploadTemporaryFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof storageControllerUploadTemporaryFiles>>
>;
export type StorageControllerUploadTemporaryFilesMutationBody =
  BodyType<StorageControllerUploadTemporaryFilesBody>;
export type StorageControllerUploadTemporaryFilesMutationError =
  ErrorType<void>;

/**
 * @summary 임시 파일 업로드 (견적 ID 불필요, 24시간 자동 삭제, 최대 10개 20MB)
 */
export const useStorageControllerUploadTemporaryFiles = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof storageControllerUploadTemporaryFiles>>,
      TError,
      { data: BodyType<StorageControllerUploadTemporaryFilesBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof storageControllerUploadTemporaryFiles>>,
  TError,
  { data: BodyType<StorageControllerUploadTemporaryFilesBody> },
  TContext
> => {
  const mutationOptions =
    getStorageControllerUploadTemporaryFilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
